import moment from 'moment-timezone';
import Datepicker from 'vue-datepicker-local';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({ from: null, to: null }),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    datepicker: Datepicker,
  },
  computed: {
    internalDateRange: {
      get() {
        if (this.value.from && this.value.to) {
          return [this.value.from, this.value.to];
        }
        return [];
      },
      set(value) {
        const result = {
          from: value[0] ? moment(value[0]).toISOString() : null,
          to: value[1] ? moment(value[1]).toISOString() : null,
        };
        this.$emit('input', result);
        return value;
      },
    },
    local() {
      return {
        dow: 0,
        hourTip: this.$t('terms.datepicker.hour-tip'),
        minuteTip: this.$t('terms.datepicker.minute-tip'),
        secondTip: this.$t('terms.datepicker.second-tip'),
        yearSuffix: this.$t('terms.datepicker.year-suffix'),
        monthsHead: [
          this.$t('terms.datetime.months_long.1'),
          this.$t('terms.datetime.months_long.2'),
          this.$t('terms.datetime.months_long.3'),
          this.$t('terms.datetime.months_long.4'),
          this.$t('terms.datetime.months_long.5'),
          this.$t('terms.datetime.months_long.6'),
          this.$t('terms.datetime.months_long.7'),
          this.$t('terms.datetime.months_long.8'),
          this.$t('terms.datetime.months_long.9'),
          this.$t('terms.datetime.months_long.10'),
          this.$t('terms.datetime.months_long.11'),
          this.$t('terms.datetime.months_long.12'),
        ],
        months: [
          this.$t('terms.datetime.months_short.1'),
          this.$t('terms.datetime.months_short.2'),
          this.$t('terms.datetime.months_short.3'),
          this.$t('terms.datetime.months_short.4'),
          this.$t('terms.datetime.months_short.5'),
          this.$t('terms.datetime.months_short.6'),
          this.$t('terms.datetime.months_short.7'),
          this.$t('terms.datetime.months_short.8'),
          this.$t('terms.datetime.months_short.9'),
          this.$t('terms.datetime.months_short.10'),
          this.$t('terms.datetime.months_short.11'),
          this.$t('terms.datetime.months_short.12'),
        ],
        weeks: [
          this.$t('terms.datepicker.days_short.su'),
          this.$t('terms.datepicker.days_short.mo'),
          this.$t('terms.datepicker.days_short.tu'),
          this.$t('terms.datepicker.days_short.we'),
          this.$t('terms.datepicker.days_short.th'),
          this.$t('terms.datepicker.days_short.fr'),
          this.$t('terms.datepicker.days_short.sa'),
        ],
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/daterangepicker/Daterangepicker.js